export const primary = {
  50: "#e3f8e5",
  100: "#b9edbd",
  200: "#8be191",
  300: "#5dd565",
  400: "#3acc44",
  500: "#17c323",
  600: "#15b120",
  700: "#129c1b",
  800: "#0f8817",
  900: "#15A320",
};
